var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[[_c('v-btn',{attrs:{"color":"primary","dark":"","fab":"","small":""},on:{"click":function($event){return _vm.getCurrentPosition()}}},[_c('v-icon',[_vm._v("mdi-cellphone-marker")])],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }